import React from "react";
import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import GF from "../../../../../lib/utils/GF";
import InputSearchDropDown from "../../inputFields/dropdown/InputSearchDropDown";

class FieldSelection extends BaseComponent {

  componentDidMount() {
    super.componentDidMount();
    this.onChangeFieldPredicateRef(null);
  }

  onChangeFieldPredicateRef(e, id, option) {
    if (GF.checkNotNull(this.props.fieldPredicateRef) && GF.checkNotNull(this.props.fieldPredicateRef.current)) {
      this.props.fieldPredicateRef.current.onFieldNameValueChange(e, option);
      this.props.fieldPredicateRef.current.onFieldLabelValueChange(e, option);
      this.props.fieldPredicateRef.current.onUpdateFieldType(e, option);
    }
  }

  onChange(e, id, option) {
    this.onChangeFieldPredicateRef(e, id, option.id);
    if (GF.checkNotNull(this.props.onChange)) {
      this.props.onChange(e, option.id);
    }
  }

  render() {
    let fieldList = [];
    let firstMenuItem = null;
    let firstMenuItemKey = null;
    if (this.props.defaultValue !== undefined && this.props.defaultValue !== null) {
      firstMenuItem = this.props.defaultValue;
    }
    if (GF.checkNotNull(this.props.children)) {
      for (let id in this.props.children) {
        let element = this.props.children[id];
        fieldList.push({id: id, label: element.label});
        if (firstMenuItem === null) {
          firstMenuItem = element.label;
          firstMenuItemKey = element.id;
        }
      }
    }
    return <InputSearchDropDown size={'small'} labelElement={'Feld'}
                                onChange={(e, id, option) => this.onChange(e, id, option)}
                                defaultValue={{id: firstMenuItemKey, label: firstMenuItem}} disableClearable={true}>
      {fieldList}
    </InputSearchDropDown>;
  }
}

FieldSelection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  fieldPredicateRef: PropTypes.object,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func
}
export default FieldSelection;
